﻿/* eslint-disable keyword-spacing */
import { mapGetters, mapState } from 'vuex';
import alertModal from './alertModal.vue';
import caLoader from './caLoader.js';

export default {
    name: 'ca-page-navigation',
    props: ['viewmodel', 'paymentpage', 'summarypage', 'tangocourl', 'tango4durl', 'mincreditpayment'],
    components: {
        'ca-alert-modal': alertModal,
        'ca-loader': caLoader
    },
    data: () => ({
        continueToSummaryflag: false
    }),
    mounted: function () {
        const textsData = {
            'cancelOrder': this.viewmodel.cancelOrderConfirmationText,
            'cancelOrderError': this.viewmodel.cancelOrderErrorMessage,
            'installmentsNotSet': this.viewmodel.installmentsNotSetMessage,
            'createExternalPayment': this.viewmodel.createExternalPaymentMessage
        };
        this.$store.dispatch('setTexts', textsData);

        const pageLoaderData = {
            'loaderResetCreditCheckNewCreditLimitLoaderTitle': this.viewmodel.resetCreditCheckNewCreditLimitLoaderTitle,
            'loaderResetCreditCheckNewCreditLimitLoaderMessage': this.viewmodel.resetCreditCheckNewCreditLimitLoaderMessage,
            'loaderGoToSummaryLoaderTitle': this.viewmodel.goToSummaryLoaderTitle,
            'loaderGoToSummaryLoaderMessage': this.viewmodel.goToSummaryLoaderMessage,
            'loaderGoToTangoLoaderTitle': this.viewmodel.goToTangoLoaderTitle,
            'loaderGoToTangoLoaderMessage': this.viewmodel.goToTangoLoaderMessage,
            'loaderGoToPaymentSelectionLoaderTitle': this.viewmodel.goToPaymentSelectionLoaderTitle,
            'loaderGoToPaymentSelectionLoaderMessage': this.viewmodel.goToPaymentSelectionLoaderMessage
        };
        this.$store.dispatch('setPageLoaderTexts', pageLoaderData);

        const buttonsData = {
            'close': this.viewmodel.closeButtonText,
            'closeContinue': this.viewmodel.closeContinueButtonText,
            'refresh': this.viewmodel.refreshButtonText,
            'cancel': this.viewmodel.cancelOrderButtonText,
            'retryCreditCheck': this.viewmodel.retryCreditCheckButtonText,
            'retryPreAuth': this.viewmodel.retryPreAuthButtonText,
            'retryJoiceCreditCheck': this.viewmodel.retryCreditCheckButtonText,
            'resubmit': this.viewmodel.reSubmitButtonText,
            'submit': this.viewmodel.submitButtonText,
            'returnToTango': this.viewmodel.returnToTangoButtonText
        };
        this.$store.dispatch('setButtonTexts', buttonsData);
    },
    methods: {
        getQueryString: function (field, url) {
            const href = url ? url : window.location.href;
            const reg = new RegExp('[?&]' + field + '=([^&#]*)', 'i');
            const string = reg.exec(href);
            return string ? string[1] : null;
        },
        cancelOrder: function () {
            this.$store.dispatch('showCancelOrderDialog');
        },
        disableContinueButton: function () {
            if (!this.areDiscountAmountsValid && !this.order.useNewDiva) {
                return true;
            }
            else if (!this.areDiscountAmountsValidByOrder && this.order.useNewDiva) {
                return true;
            }

            if (this.customerWantsCreditAgreement) {
                if (this.creditSelected) {
                    if (!this.areInstallmentsSelected) {
                        return true;
                    }
                    if (this.order && !this.order.useNewDiva) {
                        const approvedCreditLimit = this.creditEvaluation.creditCheckResult.approvedCreditLimit.amount;
                        if (this.preAuth.availableAmount < this.creditAgreement.totalCredit) {
                            if (!this.creditEvaluation.selectedCreditLimit || this.creditEvaluation.selectedCreditLimit > approvedCreditLimit) {
                                return true;
                            }
                            if (!this.creditEvaluation.creditCheckResult.approved) {
                                return true;
                            }
                        }

                        if (approvedCreditLimit > 0) {
                            const availableAmount = approvedCreditLimit + this.preAuth.availableAmount - this.preAuth.creditLimit;
                            if (availableAmount < this.creditAgreement.totalCredit) {
                                return true;
                            }
                        }
                    }
                    else {
                        // eslint-disable-next-line no-lonely-if
                        if (this.mincreditpayment > this.creditAgreement.totalCredit) {
                            return true;
                        }
                    }
                    if (this.collectPBSinfo && !this.isPBSInfoValid.valid) {
                        return true;
                    }
                }
            }
            else {
                if (this.creditSelected && parseInt(this.mincreditpayment, 10) > this.creditAgreement.payNow && this.order.useNewDiva) {
                    return true;
                }
            }

            return false;
        },
        continueToSummary: function () {
            let redirectUrl = this.summarypage + "?guid=" + this.orderGuid + "&host=" + this.getQueryString('host');
            if (this.order && !this.order.useNewDiva) {
                if (!this.creditPaymentSelected && this.customerWantsCreditAgreement) {
                    this.$store.dispatch('resetCreditLimit', redirectUrl);
                } else if (this.collectPBSinfo && this.creditPaymentSelected) {
                    this.$store.dispatch('createExternalPayment', {
                        'getCreateExternalPaymentLoaderTitle': this.viewmodel.getCreateExternalPaymentLoaderTitle,
                        'getCreateExternalPaymentLoaderMessage': this.viewmodel.getCreateExternalPaymentLoaderMessage,
                        'redirectUrl': redirectUrl
                    });
                } else {
                    var loaderData = {
                        'loaderTitle': this.pageLoader.loaderGoToSummaryLoaderTitle,
                        'loaderMessage': this.pageLoader.loaderGoToSummaryLoaderMessage
                    };

                    this.showLoader(loaderData)
                    window.location = redirectUrl;
                }
            }
            else {
                var loaderData = {
                    'loaderTitle': this.pageLoader.loaderGoToSummaryLoaderTitle,
                    'loaderMessage': this.pageLoader.loaderGoToSummaryLoaderMessage
                };

                this.showLoader(loaderData);
                window.location = redirectUrl;

            }
        },
        validationContinueSummary() {
            const joiceApprovedCreditLimit = Number(this.joiceCreditCheck.creditAccountMaxAvailableAmount);
            if (joiceApprovedCreditLimit > 0) {
                if (this.joiceCreditCheck.status === "APPROVED") {
                    this.continueToSummaryflag = false;
                    const redirectUrl = this.summarypage + "?guid=" + this.orderGuid + "&host=" + this.getQueryString('host');
                    if (!this.creditPaymentSelected && this.customerWantsCreditAgreement) {
                        this.$store.dispatch('resetCreditLimit', redirectUrl);
                    }
                    else if (this.creditPaymentSelected) {
                        this.$store.dispatch('createExternalPayment', {
                            'getCreateExternalPaymentLoaderTitle': this.viewmodel.getCreateExternalPaymentLoaderTitle,
                            'getCreateExternalPaymentLoaderMessage': this.viewmodel.getCreateExternalPaymentLoaderMessage,
                            'redirectUrl': redirectUrl
                        });
                    } else {
                        const loaderData = {
                            'loaderTitle': this.pageLoader.loaderGoToSummaryLoaderTitle,
                            'loaderMessage': this.pageLoader.loaderGoToSummaryLoaderMessage
                        };

                        this.showLoader(loaderData)
                        window.location = redirectUrl;
                    }
                }
            }
        },
        returnToTango: function () {
            if (!this.areInstallmentsSelected) {
                this.$store.dispatch('showInstallmentsNotSetDialog');
            } else {
                const redirectUrl = this.pageDetails.tangoRedirectUrl + "/Ordering/OrderCapture.aspx?guid=" + this.orderGuid;
                if (this.order && !this.order.useNewDiva) {
                    if (this.collectPBSinfo && this.isPBSInfoValid.valid && this.creditPaymentSelected) {
                        this.$store.dispatch('createExternalPayment', {
                            'getCreateExternalPaymentLoaderTitle': this.viewmodel.getCreateExternalPaymentLoaderTitle,
                            'getCreateExternalPaymentLoaderMessage': this.viewmodel.getCreateExternalPaymentLoaderMessage,
                            'redirectUrl': redirectUrl
                        });
                    } else {
                        const loaderData = {
                            'loaderTitle': this.pageLoader.loaderGoToTangoLoaderTitle,
                            'loaderMessage': this.pageLoader.loaderGoToTangoLoaderMessage
                        };

                        this.showLoader(loaderData);
                        window.location = redirectUrl;
                    }
                }
                else {
                    if (this.isPBSInfoValid.valid && this.creditPaymentSelected) {
                        this.$store.dispatch('createExternalPayment', {
                            'getCreateExternalPaymentLoaderTitle': this.viewmodel.getCreateExternalPaymentLoaderTitle,
                            'getCreateExternalPaymentLoaderMessage': this.viewmodel.getCreateExternalPaymentLoaderMessage,
                            'redirectUrl': redirectUrl
                        });
                    } else {
                        const loaderData = {
                            'loaderTitle': this.pageLoader.loaderGoToTangoLoaderTitle,
                            'loaderMessage': this.pageLoader.loaderGoToTangoLoaderMessage
                        };

                        this.showLoader(loaderData);
                        window.location = redirectUrl;
                    }
                }
            }
        },
        returnToPayment: function () {
            this.$store.dispatch('deactivateModal');
            var loaderData = {
                'loaderTitle': this.pageLoader.loaderGoToPaymentSelectionLoaderTitle,
                'loaderMessage': this.pageLoader.loaderGoToPaymentSelectionLoaderMessage
            };

            this.showLoader(loaderData)
            window.location = this.paymentpage + "?guid=" + this.orderGuid + "&host=" + this.getQueryString('host');
        },
        disableSubmitOrderButton: function () {
            if (!this.contracts.contractsSigned) {
                return true;
            }
            return false;
        },
        checkPageUrl: function () {
            if (window.location.pathname.replace(/\/$/, "") == this.paymentpage.replace(/\/$/, "")) {
                this.$store.dispatch('checkPaymentPage', { 'isPaymentPage': true, 'paymentUrl': this.paymentpage, 'summaryUrl': this.summarypage, 'tangocourl': this.tangocourl, 'tango4durl': this.tango4durl });
            } else {
                this.$store.dispatch('checkPaymentPage', { 'isPaymentPage': false, 'paymentUrl': this.paymentpage, 'summaryUrl': this.summarypage, 'tangocourl': this.tangocourl, 'tango4durl': this.tango4durl });
            }
        },
        submitOrder: function () {
            if (this.order && this.order.useNewDiva) {
                this.$store.dispatch('submitOrderForRemoteChannel');
            }
            else {
                this.$store.dispatch('submitOrder');
            }

        },
        submitOrderForRemoteChannel: function () {
            this.$store.dispatch('submitOrderForRemoteChannel');
        },
        showLoader: function (data) {
            this.pageLoader.showLoader = true;

            this.pageLoader.loaderTitle = data.loaderTitle;
            this.pageLoader.loaderMessage = data.loaderMessage;
        }
    },
    created: function () {
        this.checkPageUrl();
    },
    watch: {
        joiceCreditCheck: {
            handler(newValue, oldValue) {
                if (newValue.stored && this.continueToSummaryflag) {
                    this.validationContinueSummary();
                }
            },
            deep: true
        }

    },
    computed:
        Object.assign(
            mapState({
                order: state => state.creditaccount.order,
                orderGuid: state => state.creditaccount.order.orderGuid,
                orderId: state => state.creditaccount.order.orderId,
                dealerCode: state => state.creditaccount.order.dealerCode,
                salesAgent: state => state.creditaccount.order.salesAgent,
                channelType: state => state.creditaccount.order.channelType,
                preAuth: state => state.creditaccount.preAuth,
                joiceCreditCheck: state => state.creditaccount.joiceCreditCheck,
                modifiableByCustomer: state => state.creditaccount.order.modifiableByCustomer,
                creditAgreement: state => state.creditaccount.creditAgreement,
                creditEvaluation: state => state.creditaccount.creditEvaluation,
                customerWantsCreditAgreement: state => state.creditaccount.customerWantsCreditAgreement,
                //directMarketing: state => state.creditaccount.customerAcceptsDirectMarketing,
                contracts: state => state.creditaccount.contracts,
                pageLoader: state => state.creditaccount.pageLoader,
                salesChannel: state => state.creditaccount.salesChannel,
                useNewDiva: state => state.order.useNewDiva,
                manualSigning: state => state.order.manualSigning
            }),
            mapGetters({
                collectPBSinfo: 'collectPBSinfo',
                isPBSInfoValid: 'isPBSInfoValid',
                pageDetails: 'pageDetails',
                contractsSignedInfo: 'contractsSignedInfo',
                areInstallmentsSelected: 'installmentsSelected',
                creditSelected: 'showCreditAgreementDetails',
                creditPaymentSelected: 'creditPaymentSelected',
                hasAnyContract: 'hasAnyContract',
                areDiscountAmountsValid: 'areDiscountAmountsValid',
                areDiscountAmountsValidByOrder: 'areDiscountAmountsValidByOrder',
                hasAnyTeliaContract: 'hasAnyTeliaContract'
            })
        )
}